module.exports = __webpack_public_path__ + "static/media/epaper-background-image.bccaa201.webp";